export enum CarouselType {    
    Community = 'community',
    Location = 'location',
    Office = 'office',
    Press = 'press',
    Stats = 'stats',
    Insights = 'insight'
}